import { useEffect } from "react"
import { Stack, Group, Title, Container } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import SecuritySection from "@pages/account-compliance/securitySection/securitySection"
import {
	useAEMDictionary,
	AEM_DICTIONARY_COLLECTIONS
} from "@AEM/hooks/useAEMDictionary"
import { useIsMobile } from "@utils/device.utils"
import { usePageTitle } from "@hooks/usePageTitle"
import styles from "@pages/profile-managment/profileManagment.module.css"
import { ComplianceRequiredModal } from "./ComplianceRequiredModal"
import { ComplianceCompleteModal } from "./ComplianceCompleteModal"
import { useAuthContext } from "@context/AuthProvider"
import {
	COMPLIANCE_MODAL_SHOWN_KEY,
	COMPLIANCE_COMPLETE_MODAL_SHOWN_KEY
} from "@utils/constants.util"
import { getComplianceStatus } from "@services/complianceService"

const AccountCompliancePage = () => {
	const { dictionary } = useAEMDictionary(
		AEM_DICTIONARY_COLLECTIONS.REGISTRATION
	)
	const { refreshUserProfile, userProfile } = useAuthContext()
	const isMobile = useIsMobile()
	const [modalOpened, { open: openModal, close: closeModal }] =
		useDisclosure(false)
	const [
		completeModalOpened,
		{ open: openCompleteModal, close: closeCompleteModal }
	] = useDisclosure(false)

	const isFullyCompliant = userProfile
		? getComplianceStatus(userProfile).compliant
		: false

	usePageTitle(dictionary?.loginAndSecurityLabel ?? "")

	useEffect(() => {
		refreshUserProfile()
	}, [refreshUserProfile])

	useEffect(() => {
		if (sessionStorage.getItem(COMPLIANCE_MODAL_SHOWN_KEY)) return
		if (isFullyCompliant) return
		sessionStorage.setItem(COMPLIANCE_MODAL_SHOWN_KEY, "1")
		openModal()
	}, [openModal, isFullyCompliant])

	useEffect(() => {
		if (sessionStorage.getItem(COMPLIANCE_COMPLETE_MODAL_SHOWN_KEY)) return
		if (!isFullyCompliant) return
		sessionStorage.setItem(COMPLIANCE_COMPLETE_MODAL_SHOWN_KEY, "1")
		openCompleteModal()
	}, [isFullyCompliant, openCompleteModal])

	return (
		<Stack gap={0}>
			<ComplianceRequiredModal opened={modalOpened} onContinue={closeModal} />
			<ComplianceCompleteModal
				opened={completeModalOpened}
				onClose={closeCompleteModal}
			/>
			<Stack className={styles.header} style={{ paddingBottom: 48 }}>
				<Group
					className={styles.headerContainer}
					justify="space-between"
					align="center"
					w="100%"
				>
					<Title className={styles.headerText} p={0} fz={32}>
						{dictionary?.accountTitle ?? ""}
					</Title>
				</Group>
			</Stack>
			<Container size="xl" w="100%" py={60} px={isMobile ? 0 : 20}>
				<SecuritySection isFullyCompliant={isFullyCompliant} />
			</Container>
		</Stack>
	)
}

export default AccountCompliancePage
